import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { AuthState, getAuthState } from '@/types/auth';

interface UseAuthGuardOptions {
  requireAuth?: boolean;
  redirectTo?: string;
  onUnauthenticated?: () => void;
}

export const useAuthGuard = ({ 
  requireAuth = true, 
  redirectTo = '/auth',
  onUnauthenticated 
}: UseAuthGuardOptions = {}) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const authState = getAuthState(user, loading);

  useEffect(() => {
    if (requireAuth && authState === AuthState.UNAUTHENTICATED) {
      if (onUnauthenticated) {
        onUnauthenticated();
      } else {
        navigate(redirectTo);
      }
    }
  }, [authState, requireAuth, redirectTo, navigate, onUnauthenticated]);

  return {
    authState,
    isAuthenticated: authState === AuthState.AUTHENTICATED,
    isLoading: authState === AuthState.LOADING,
    user
  };
};